import { BaseEntity, PaginatedEntity } from '@core/entities/_extra';
import { Expose, Transform, Type } from 'class-transformer';
import { RoomType } from '@core/enums';
import { SafeUrl } from '@angular/platform-browser';
import { CourseBookingDetails, CourseEntity } from '@core/entities/course.entity';

export class RoomsListEntity extends PaginatedEntity {
  @Type(() => RoomEntity)
  @Expose({ name: 'room' })
  rooms: RoomEntity[] = [];
}

export class RoomEntity extends BaseEntity {
  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  name = '';

  type: RoomType;

  @Expose({ name: 'no_of_persons' })
  noOfPersons = 0;
  price = 0;

  @Expose({ name: 'active_from' })
  activeFrom = '';

  @Expose({ name: 'active_to' })
  activeTo = '';

  @Expose()
  @Transform((item) => encodeURIComponent(item.value), { toPlainOnly: true })
  @Transform((item) => decodeURIComponent(item.value), { toClassOnly: true })
  description = '';

  @Expose({ name: 'room_email' })
  email = '';

  @Expose({ name: 'room_address' })
  address = '';

  @Expose({ name: 'phone_no' })
  phoneNo = '';

  @Type(() => RoomTag)
  roomTags: RoomTag[] = [];

  @Expose({ name: 'room_availablity' })
  @Type(() => RoomAvailability)
  availability: RoomAvailability[] = [];

  @Expose({ name: 'roomBooking' })
  @Type(() => RoomBooking)
  roomBookings?: RoomBooking[];

  @Expose({ name: 'roomBookingDetails' })
  @Type(() => CourseBookingDetails)
  roomBookingDetails?: CourseBookingDetails[];

  image: string;

  /**
   * for POST/PUT request
   */
  author = 0;
  tags: string[] = [];
  weekdays: any[] = [];

  // For UI use only
  imageUrl: string | SafeUrl;

  constructor(init: Partial<RoomEntity>) {
    super(init);
    this.initEntity(init);
  }
}

export class RoomTag {
  @Expose({ name: 'tag_name' })
  tagName = '';

  id = 0;

  @Expose({ name: 'room_id' })
  roomId = 0;

  @Expose({ name: 'tag_id' })
  tagId = 0;
}

export class RoomAvailability {
  id = 0;

  @Expose({ name: 'room_id' })
  roomId = 0;
  weekday = '';

  @Expose({ name: 'time_from' })
  timeFrom = '';

  @Expose({ name: 'time_to' })
  timeTo = '';
}

export class RoomBooking {
  id = 0;

  @Expose({ name: 'room_id' })
  roomId = 0;

  @Expose({ name: 'course_id' })
  courseId = 0;

  @Expose({ name: 'event_id' })
  eventId = 0;

  @Expose({ name: 'date_from' })
  dateFrom = '';

  @Expose({ name: 'start_time' })
  startTime = '';

  @Expose({ name: 'end_time' })
  endTime = '';

  @Expose({ name: 'course' })
  @Type(() => CourseEntity)
  course: CourseEntity;
}
